import { render, staticRenderFns } from "./UcrsButton.vue?vue&type=template&id=601d8757"
import script from "./UcrsButton.vue?vue&type=script&lang=js"
export * from "./UcrsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports